export const fetchSingleObligationPayload = (appId, orgId, selectedStep, opportunityId, chartUniqueId) => {
    return {
        appId: appId,
        orgId: orgId,
        dataModelId: selectedStep.dataModel,
        opportunityId: opportunityId, 
        dataUniqueId: chartUniqueId + '_getsingleobligation'
    }
}